import request from '@/utils/request'
import qs from 'qs'

export function uploadAppLog(data) {
    data = qs.stringify(data)
    return request({
        url: '/appLog/uploadAppLog',
        method: 'post',
        data
    })
}

export function getUserRecord(data) {
    data = qs.stringify(data)
    return request({
        url: '/userRecord/getUserRecord',
        method: 'post',
        data
    })
}

export function getMyMedalList(data) {
    data = qs.stringify(data)
    return request({
        url: '/medal/getMyMedalList',
        method: 'post',
        data
    })
}

export function getChallengeMedal(data) {
    data = qs.stringify(data)
    return request({
        url: '/medal/getChallengeMedal',
        method: 'post',
        data
    })
}

export function getMedalList(data) {
    data = qs.stringify(data)
    return request({
        url: '/medal/getMedalList',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/my.js